module.exports = __webpack_public_path__ + "images/a14ac2fb.img_chs_win_5.png";


//////////////////
// WEBPACK FOOTER
// ./images/img_chs_win_5.png
// module id = 284
// module chunks = 0